<template>
  <iframe
    ref="frame"
    :src="embedUrl"
    :title="`${title} trailer preview`"
    class="title-trailer-frame"
    tabindex="-1"
    aria-hidden="true"
    allow="autoplay; encrypted-media; picture-in-picture"
    referrerpolicy="strict-origin-when-cross-origin"
  ></iframe>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, ref } from 'vue'
import { loadYouTubePlayerApi } from '@/services/youtubePlayerApi'

const props = defineProps({ videoId: { type: String, required: true }, title: { type: String, default: '' } })
const emit = defineEmits(['playing', 'ended', 'unavailable'])
const frame = ref(null)
let player
let disposed = false
const embedUrl = computed(() => {
  const params = new URLSearchParams({ enablejsapi: '1', autoplay: '0', playsinline: '1', controls: '1', rel: '0', origin: window.location.origin })
  return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(props.videoId)}?${params}`
})

onMounted(async () => {
  try {
    const YT = await loadYouTubePlayerApi()
    if (disposed || !frame.value) return
    player = new YT.Player(frame.value, {
      events: {
        onReady(event) {
          if (disposed) { event.target.destroy(); return }
          event.target.mute()
          event.target.playVideo()
        },
        onStateChange(event) {
          if (disposed) return
          if (event.data === 1) emit('playing')
          if (event.data === 0) emit('ended')
        },
        onError() { if (!disposed) emit('unavailable') },
        onAutoplayBlocked() { if (!disposed) emit('unavailable') },
      },
    })
  } catch {
    if (!disposed) emit('unavailable')
  }
})

onBeforeUnmount(() => {
  disposed = true
  try { player?.destroy() } catch { /* player may already have removed its iframe */ }
  player = null
})
</script>
